// Copyright © 2019 Atomic.io Limited. All rights reserved.
import {useState, useEffect} from 'react'
import {AtomicLogo, Logo, SettingsTrigger} from '../components/icons'
import {DropdownMenu} from '../components/dropdown'
import {Settings} from '../util/settings'
import {getSDKVersion} from '../util/helpers'
import {isFeatureFlagBypassActive} from '../features'

const NavBadges = () => (
  <div className="nav-badges">
    <span className="nav-badge">SDK {getSDKVersion()}</span>
    {isFeatureFlagBypassActive() && (
      <span className="nav-badge nav-badge-warning">
        Feature flags bypassed
      </span>
    )}
  </div>
)

const Nav = ({
  changeRoute,
  onSettingChanged,
  onLogout,
  onRefreshRuntimeVariables,
  onConfigureSDKFeatures,
  onLoginToSDK,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <nav className={Settings.configuration.backgroundUrl && 'nav-hidden'}>
      {!Settings.configuration.backgroundUrl && (
        <AtomicLogo
          href={Settings.currentEnvironment().workbenchUrl}
          target="_blank"
          title="Open Workbench"
        >
          <Logo width={'22'} height={'22'} style={{marginTop: '-2px'}} />
        </AtomicLogo>
      )}

      {!Settings.configuration.backgroundUrl && <NavBadges />}

      {isOpen && (
        <DropdownMenu
          changeRoute={changeRoute}
          onSettingChanged={onSettingChanged}
          onLogout={onLogout}
          onClose={e => {
            setIsOpen(false)
            e.stopPropagation()
          }}
          onRefreshRuntimeVariables={onRefreshRuntimeVariables}
          onConfigureSDKFeatures={onConfigureSDKFeatures}
          onLoginToSDK={onLoginToSDK}
        />
      )}

      <SettingsTrigger
        className={
          Settings.configuration.backgroundUrl && 'settings-trigger-hidden'
        }
        onClick={() => setIsOpen(!isOpen)}
        isOpen={isOpen}
      ></SettingsTrigger>
    </nav>
  )
}

/**
 * The landing screen of the sample app.
 */
const Dashboard = ({
  changeRoute,
  cardCount,
  onLaunch,
  onSettingChanged,
  onLogout,
  onRefreshRuntimeVariables,
  onConfigureSDKFeatures,
  onOpenLauncher,
  onLoginToSDK,
}) => {
  // Run once on mount only; `onLaunch` is recreated on every render of the parent.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(onLaunch, [])
  const launcherDisabled = Settings.sdkFeatures.customiseLauncherButton
    ? JSON.parse(Settings.sdkFeatures.customiseLauncherButton).disabled
    : false

  return (
    <>
      <Nav
        changeRoute={changeRoute}
        onLogout={onLogout}
        onSettingChanged={onSettingChanged}
        onRefreshRuntimeVariables={onRefreshRuntimeVariables}
        onConfigureSDKFeatures={onConfigureSDKFeatures}
        onLoginToSDK={onLoginToSDK}
      />
      {Settings.configuration.backgroundUrl && (
        <div className="background-image-container">
          <img
            className="background-image"
            src={Settings.configuration.backgroundUrl}
          />
        </div>
      )}
      {['launcher', 'multiple'].includes(Settings.configuration.embedMode) && (
        <button
          type="button"
          className="open-launcher-button button-light button-bordered button-small"
          onClick={onOpenLauncher}
        >
          Open launcher
        </button>
      )}
      {!launcherDisabled && (
        <div id="badge" style={{display: cardCount > 0 ? 'block' : 'none'}}>
          {cardCount}
        </div>
      )}
    </>
  )
}

export {Dashboard}
